import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';
import theme from '@themes/theme';

type Props = {
  onTryIt: () => void;
};

export const ChatHashTagOnboardingTooltip: React.FC<Props> = ({ onTryIt }) => {
  const { t } = useTranslation();
  return (
    <Box
      backgroundColor='greenSecondary'
      borderRadius='l'
      padding='m'
      style={{
        width: 313,
        gap: theme.spacing.m,
        shadowColor: theme.colors.black,
        shadowOpacity: 0.05,
        shadowOffset: { width: 0, height: 5 },
        shadowRadius: 25,
        elevation: 5,
      }}>
      {/* Text content */}
      <Box style={{ gap: theme.spacing.xs }}>
        <Text variant='labelEmphasized' color='white'>
          {t('models:chat.onboarding.hashTagStep1.title')}
        </Text>
        <Text variant='webBodySecondary' color='white'>
          {t('models:chat.onboarding.hashTagStep1.description')}
        </Text>
      </Box>

      {/* Footer: step indicator + CTA */}
      <Box
        flexDirection='row'
        alignItems='center'
        style={{ gap: theme.spacing.m }}>
        <Box flex={1}>
          <Text variant='webBodySecondary' color='grey01'>
            {t('models:chat.onboarding.hashTagStep1.step')}
          </Text>
        </Box>
        <TouchableOpacity onPress={onTryIt}>
          <Box
            backgroundColor='black'
            borderRadius='xxl'
            paddingHorizontal='m'
            style={{
              paddingVertical: theme.spacing.xxs,
              shadowColor: theme.colors.black,
              shadowOpacity: 0.12,
              shadowOffset: { width: 2, height: 2 },
              shadowRadius: 6,
            }}>
            <Text variant='buttonLabel' color='white'>
              {t('models:chat.onboarding.hashTagStep1.cta')}
            </Text>
          </Box>
        </TouchableOpacity>
      </Box>

      {/* Arrow — rotated square, same pattern as TooltipPopup */}
      <Box
        style={{
          position: 'absolute',
          bottom: -10,
          left: 28,
          width: 22,
          height: 22,
          backgroundColor: theme.colors.greenSecondary,
          borderBottomLeftRadius: theme.borderRadii.xxxs,
          borderBottomRightRadius: theme.borderRadii.xxs,
          borderTopLeftRadius: theme.borderRadii.xxxs,
          borderTopRightRadius: theme.borderRadii.xxxs,
          transform: [{ rotate: '45deg' }],
        }}
      />
    </Box>
  );
};
